import types from "./types";

export default Object.values(types);
